/*eslint-disable @typescript-eslint/naming-convention*/
export var EAlkInputType;
(function (EAlkInputType) {
    EAlkInputType["FILLED"] = "filled";
    EAlkInputType["CLEAR"] = "clear";
    EAlkInputType["CLEAR_NO_BASELINE"] = "clear-no-baseline";
})(EAlkInputType || (EAlkInputType = {}));
